import { RefObject, useLayoutEffect, useRef } from 'react';

const useScrollToTop = (resetKey?: string): RefObject<HTMLDivElement> => {
  const scrollableBody = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    scrollableBody.current?.scrollTo(0, 0);
  }, [resetKey]);

  return scrollableBody;
};

export default useScrollToTop;
